import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/landingPage";
import AuthPage from "./pages/auth";
import ComingSoon from "./pages/comingSoon";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth/*" element={<AuthPage />} />
        <Route path="/orders" element={<ComingSoon/>} />
      </Routes>
    </Router>
  );
}

export default App;
